import styled from 'styled-components';

export const Clickable = styled.div`
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: white;
  }
`;

export const Jfjaafj = styled.div`
  color: red;
`;
